import { useField } from 'informed';
import { CheckboxInput } from './common';

import type { CheckboxProps } from './common/CheckboxInput';

interface Props extends CheckboxProps {
  field: string;
  initialValue?: any;
  mask?: (value: any) => any;
  onValueChange?: (value: any) => void;
  validate?: (value: any, values?: any) => undefined | string;
  validateOnChange?: boolean;
}

const Checkbox = ({ size, ...props }: Props) => {
  const { fieldState, fieldApi, ref, render, userProps } = useField({
    ...props
  });

  const { onChange, onBlur, ...rest } = userProps;

  const handleOnBlur = (ev) => {
    fieldApi.setTouched(true);
    if (onBlur) onBlur(ev);
  };

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (ev) => {
    fieldApi.setValue(ev.target.checked);
    if (onChange) onChange(ev);
  };

  return render(
    <CheckboxInput
      {...rest}
      inputRef={ref}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      checked={!!fieldState.value}
      size={size}
    />
  );
};

export default Checkbox;
